if (typeof window !== 'undefined') {
  // Use CommonJS require to bypass strict ESM read-only bindings in Webpack/Turbopack
  // eslint-disable-next-line global-require
  const ReactDOM = require('react-dom')

  if (!ReactDOM.findDOMNode) {
    ReactDOM.findDOMNode = function (componentInstance: any) {
      if (!componentInstance) {
        return null
      }
      if (componentInstance instanceof HTMLElement) {
        return componentInstance
      }

      // Read the stable React internal Fiber keys (used natively by React DevTools)
      const fiberKey = Object.keys(componentInstance).find(
        (key) =>
          key.startsWith('__reactInternalInstance$') ||
          key.startsWith('__reactFiber$'),
      )

      if (fiberKey) {
        let currentFiber = componentInstance[fiberKey]
        while (currentFiber) {
          if (currentFiber.stateNode instanceof HTMLElement) {
            return currentFiber.stateNode
          }
          currentFiber = currentFiber.child
        }
      }

      // Fallback selector for customized ref wrappers
      return componentInstance.inputRef?.current || null
    }
  }
}
